import React, { useState } from 'react';

const FAQ_ITEMS = [
  {
    question: "How do I get started with SkillBinder?",
    answer: "Sign up for free and take our career assessment. We\'ll create a personalized plan based on your occupation and experience level."
  },
  {
    question: "What\'s included in the Premium subscription?",
    answer: "Premium includes unlimited career plans, ZIP-level salary insights, resume builder, weekly check-ins, and export features for $19.99/month."
  },
  {
    question: "Can I cancel my subscription anytime?",
    answer: "Yes, you can cancel your Premium subscription at any time. You'll continue to have access until your current billing period ends."
  },
  {
    question: "How accurate are the salary insights?",
    answer: "Our salary data is sourced from multiple industry databases and updated regularly. ZIP-level insights (Premium feature) provide localized market rates."
  },
  {
    question: "Do you support my occupation?",
    answer: "We support healthcare, beauty/wellness, trades, business, and tech roles. If your occupation isn't listed, contact us - we're always expanding."
  },
  {
    question: "Is my data secure?",
    answer: "Yes, we take privacy seriously. Your personal information is encrypted and never shared with third parties. See our Privacy Policy for details."
  }
];

export default function FAQSection() {
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (index) => {
    setOpenItems(prev => {
      const newSet = new Set(prev);
      if (newSet?.has(index)) {
        newSet?.delete(index);
      } else {
        newSet?.add(index);
      }
      return newSet;
    });
  };

  return (
    <div className="bg-card rounded-2xl border border-border p-6 shadow-sm">
      <h2 className="text-xl font-semibold text-card-foreground mb-6">Frequently Asked Questions</h2>
      
      <div className="space-y-4">
        {FAQ_ITEMS?.map((item, index) => (
          <div key={index} className="border border-border rounded-lg">
            <button
              onClick={() => toggleItem(index)}
              className="w-full text-left px-4 py-3 flex items-center justify-between hover:bg-muted/50 transition-colors rounded-lg"
            >
              <span className="font-medium text-card-foreground">{item?.question}</span>
              <span className={`text-muted-foreground transition-transform ${
                openItems?.has(index) ? 'rotate-180' : ''
              }`}>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </button>
            
            {openItems?.has(index) && (
              <div className="px-4 pb-3">
                <p className="text-muted-foreground">{item?.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <p className="text-sm text-muted-foreground mt-6">
        Don't see your question? Send us a message and we'll get back to you quickly.
      </p>
    </div>
  );
}